/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingBaseStock } from '../../models/thermoforming-base-stock';
import { UpdateThermoformingBaseStockDto } from '../../models/update-thermoforming-base-stock-dto';

export interface UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params {
  id: number;
      body: UpdateThermoformingBaseStockDto
}

export function updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStock>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBaseStock>;
    })
  );
}

updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock.PATH = '/api/mgmt/thermoforming-base-stock/{id}';
